import { defineTokens } from '@chakra-ui/react'

// Primitive token overrides for the next theme (colors, fonts, radii, spacing, …).
// Values come from the Pro LP mockups (project-plans/active/2026-10-26-pro-lp-conversion-flow/mockups),
// which fill the gaps between existing scale steps.
export const tokens = defineTokens({
  colors: {
    purple: {
      // Card surface: one step up from panel (900), below container (800).
      '850': { value: '#211f30' },
      // Raised neutral fill: tracks, chips, avatars. Between container (800) and 700.
      '750': { value: '#2a2938' },
    },
    // Warm off-white for light-mode containers, between white and orange.50.
    sand: {
      '50': { value: '#fbf6f0' },
    },
  },
  // Lighter type. Components hardcode bold/extrabold/black (300+ uses), so the heavy names are
  // capped at 600 here instead of edited per component. 600 is the heaviest weight the LP uses.
  // Decide at cutover whether to keep this remap or rename the weights in components.
  fontWeights: {
    bold: { value: '600' },
    extrabold: { value: '600' },
    black: { value: '600' },
  },
})
